function isNull (Str) {
  var isN = false
  if (Str === null || Str === undefined || Str === 'undefined' || Str === '' || Str === 'null') {
    isN = true
  } else {
    isN = false
  }
  return isN
}

function getDateforNum (days) {
  return new Date(new Date().getTime() + (days * 24 * 60 * 60 * 1000))
}

function formatDate (date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function padLeftZero (str) {
  return ('00' + str).substr(str.length)
}

function getQueryString (name) {
  var after = window.location.hash.split('?')[1]
  if (after) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(r[2])
    }
    return null
  }
}



var hostCopyRight = [
  {'zj.52khg.cn':'纸巾侠'},
  {'gxzj.laibaozhi.com':'共享纸巾'},
  {'sj.laibaozhi.com':'来包纸'},
  {'suoli':'索力'},
  {'lx.liuxiangok.cn':'流享'},
  {'xgl.laibaozhi.com':'香格里共享纸巾'},
  {'yunzhi.ynstkz.com':'芸纸共享纸巾'},
  {'zj.dingdangwu.cn':'纸巾侠'}
]



function getCopyRight(){
   var host = window.location.host

  for (var i=0; i<hostCopyRight.length; i++){
    var temp = hostCopyRight[i]

    // console.log("temp = "+JSON.stringify(temp))

    for(var p in temp){

    //  console.log("p="+p+",host="+host)

     if(host.indexOf(p)>=0){
       return temp[p]
     }
    }


  }

  return ''
}


function getAuthority(auth){
  var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
  var userInfo = JSON.parse(userInfoStr)
  if (!isNull(userInfo.showPage) && userInfo.showPage.indexOf(auth)>-1){
    return true
  }else{
    return false
  }
}


// 很关键
export {
    isNull,
    getDateforNum,
    formatDate,
    getQueryString,
    getCopyRight,
    getAuthority
}



// WEBPACK FOOTER //
// ./src/js/tool.js